const mutations = {
  SET_PRODUCTS_PAGINATION (state, data) {
    let paginationInfo = JSON.parse(JSON.stringify(data))
    if (paginationInfo.total_elements <= 30 ) {
      paginationInfo.total_pages = 1
    } else {
      paginationInfo.total_pages = Math.trunc(paginationInfo.total_elements/30)+1
    }
    state.pagination = {
      ...state.pagination,
      ...paginationInfo
    }
  },
  SET_PRODUCTS_LIST (state, data) {
    state.items = JSON.parse(JSON.stringify(data))
  },
  SET_PRODUCT_TO_EDIT (state, data) {
    const productInfo = JSON.parse(JSON.stringify(data))
    state.productToEdit = {
      ...state.productToEdit,
      ...productInfo
    }
  },
  UNSET_PRODUCT_TO_EDIT (state, data) {
    state.productToEdit = {
      product_id: null,
      product_name: '',
      product_owner_name: '',
      product_is_active: true,
      product_updated_at: ''
    }
  },
  SET_PAGE (state, data) {
    state.page = data
  },
  SET_PAGE_SIZE (state, data) {
    state.size = data
  },
  SET_CURRENT_PAGE (state, data) {
    state.currentPage = data
  },
  SET_FILTER (state, data) {
    state.is_active = data
  },
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_LOADING_CLEAR (state, data) {
    state.loadingClear = data
  },
  SET_PRODUCT_FILTER (state, data) {
    state.product_id = data
  },
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/product/mutations.js